import Stepper from "@/components/common/Stepper";
import InvitePatientForm from "@/features/templates/features/invite-patient/InvitePatientForm";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/new/diary/invite/user")({
  component: InviteUserPage,
});

function InviteUserPage() {
  const search = Route.useSearch();
  return (
    <div className="mx-auto max-w-2xl">
      <Stepper
        steps={[
          {
            stage: "past",
            words: "Confirm Diary Details",
            route: { to: "/new/diary/invite/diary", search: search },
          },
          { stage: "current", words: "Add Patient Information", route: Route },
        ]}
      />
      <InvitePatientForm quickstart={search} />
    </div>
  );
}
